// src/features/Customers/CustomersList.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'react-oidc-context';
import { licenseService } from '../../apiService';
import { STAGE_ORDER, stageLabel } from '../../lib/onboardingDisplay';

export default function CustomersList() {
  const auth = useAuth();
  const navigate = useNavigate();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = auth.user?.access_token;
    if (!token) { setLoading(false); return; }
    let cancelled = false;
    licenseService.listCustomers(token)
      .then((res) => { if (!cancelled) { setCustomers(res.customers || []); setLoading(false); } })
      .catch((e) => { if (!cancelled) { setError(e.message || 'Failed to load customers'); setLoading(false); } });
    return () => { cancelled = true; };
  }, [auth.user?.access_token]);

  if (loading) return <p>Loading customers…</p>;
  if (error) return <p role="alert">{error}</p>;

  return (
    <div className="customers-list">
      <h1>Customers</h1>
      <table>
        <thead>
          <tr><th>Customer</th><th>Number</th><th>Total</th>{STAGE_ORDER.map((s) => <th key={s}>{stageLabel(s)}</th>)}</tr>
        </thead>
        <tbody>
          {customers.map((c) => {
            const key = c.customerNumber || '__unassigned__';
            const clickable = !!c.customerNumber;
            return (
              <tr
                key={key}
                className={clickable ? 'customer-row customer-row--clickable' : 'customer-row'}
                onClick={clickable ? () => navigate(`/customers/${c.customerNumber}`) : undefined}
              >
                <td>{c.customerName || '(Unassigned)'}</td>
                <td>{c.customerNumber || '—'}</td>
                <td>{c.total}</td>
                {STAGE_ORDER.map((s) => <td key={s}>{c.counts?.[s] || 0}</td>)}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
